import { easings, useSpring, useTransition } from 'react-spring';

const useAnimations = (isOpen: boolean, contanerHeight: number) => {
  const { easeInSine } = easings;

  const dropdownAnimation = useTransition(isOpen, {
    from: { maxHeight: 0 },
    enter: { maxHeight: contanerHeight },
    leave: { maxHeight: 0 },
    config: { tension: 1600, friction: 200 },
  });

  const filtersAccordianAnimation = useSpring({
    from: {
      opacity: 0,
    },
    to: {
      opacity: isOpen ? 1 : 0,
    },
    config: {
      duration: 150,
      easing: easeInSine,
    },
  });

  return { dropdownAnimation, filtersAccordianAnimation };
};

export default useAnimations;
